import { List } from "antd";

export function getPendingCases() {

  return {
    id:5,
    userKey:'pending cases',
    dataColumns:[
      {
        title: 'AP Pending Cases',
        displayType: 'SUMMARY',
        columns: [
          {
            id: 1,
            title: 'Total',
            displayType: 'WORKABLE',
            description: 'Total',
            columnKey: 'totalCount',
          },
          {
            id: 2,
            title: 'New',
            displayType: 'STRING',
            description: 'New',
            columnKey: 'newCount',
          },
          {
            id: 3,
            title: 'Critical',
            displayType: 'CRITICAL',
            description: 'Critical',
            columnKey: 'criticalCount',
          },
        ],
      },

    ],

  };
}
export function getGeneralSubQueueMetaData() {
  return {
    id: 1,
    width: '50%',
    userKey: 'supervisor',
    dataColumns: [
      /**/
      {
        displayType: 'QUEUE_VIEW',
        id: 1,
        title: 'Priority',
        queueKey: 'myQueue',
        apiKey: 'my_queue_api',
        dropDownIsVisible: false,
      },
      {
        id: 2,
        displayType: 'QUEUE_VIEW',
        title: 'Default',
        queueKey: 'exceptionQueue',
        apiKey: 'queueExceptionList',
        dropDownIsVisible: false,
      },
      {
        id: 3,
        displayType: 'QUEUE_VIEW',
        title: 'Specialty',
        queueKey: 'exceptionQueue',
        apiKey: 'queueExceptionList',
        dropDownIsVisible: false,
      }],
  };
}
export function getGeneralQueueMetaData() {
  return {
    id: 1,
    width: '50%',
    userKey: 'supervisor',
    dataColumns: [
      /**/
      {
        displayType: 'QUEUE_VIEW',
        id: 1,
        title: 'My Queues',
        queueKey: 'myQueue',
        apiKey: 'my_queue_api',
        dropDownIsVisible: true,
        dropDownselection: {
          id: 1,
          defSelectKey: 'regionDataList',
        },
       
      },
    
      {
        id: 3,
        displayType: 'QUEUE_VIEW',
        title: 'Exceptions Queues',
        queueKey: 'exceptionQueue',
        apiKey: 'queueExceptionList',
        dropDownIsVisible: false,
      }],
  };
}

export function getAssignedCasesMetaData(permission) {
  if (permission !== undefined && permission !== null && permission.case.canAssignCase) {
    return {
      id: 2,
      width: '50%',
      userKey: 'analyst',
      dataColumns: [
        /*{
        title: 'Assigned Cases',
        displayType: 'SUMMARY',
        showGroupSearch: true,
        columns: [
          {
            id: 1,
            title: 'Available To Work',
            displayType: 'STRING',
            description: 'Available To Work',
            columnKey: 'availableToWorkCount',
          },
          {
            id: 2,
            title: 'Completed',
            displayType: 'STRING',
            description: 'Completed',
            columnKey: 'completedCount',
          },
          {
            id: 3,
            title: 'Critical',
            displayType: 'CRITICAL',
            description: 'Critical',
            columnKey: 'assignedCasesCriticalCount',
          },
        ],
      }*/],
      config: [
        {
          title: 'Groups',
          description: '',
          displayType: 'DROPDOWN',
          width: '25%',
          defaultIsVisible: true,
        },
        {
          title: 'Search',
          description: '',
          displayType: 'SEARCH',
          width: '25%',
          defaultIsVisible: true,
        },
        {
          title: '',
          description: '',
          displayType: 'EXPAND',
          width: '50%',
          defaultIsVisible: true,
        },
      ],
    };
  } else {
    return {}
  }
}
